<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll">
            <!-- nav -->
            <div class="review-nav bg-white">
                <router-link tag="div" class="review-nav-item div--inlineBlock"  to="/Rccl.Review/ReviewPicture/OwnPicture"><span>我的美图</span></router-link>
                <div class="line div--inlineBlock"></div>
                <router-link tag="div" class="review-nav-item div--inlineBlock active" to="/Rccl.Review/Travel/OwnReview"><span>我的游记</span></router-link>
            </div>
            <!-- review-list -->
            <div class="list-container infinite-scroll bg-white">
                <div class="review-successPic">
                    <img src="https://resource.rcclchina.com.cn/images/review_upload_success.jpg" />
                </div>
                <!-- list -->
                <div class="review-list bg-white"></div>
                <div class="review-no">
                    <div class="review-list-nodata">
                        <img src="../../assets/edit.png" alt="Alternate Text" />
                        <p>您目前尚未上传游记，请至电脑端完成游记撰写，</p>
                        <p>分享您与皇家游轮的故事</p>
                    </div>
                    <div class="button_content">
                        <p><router-link to="/Rccl.Review/Travel/TravelNotes" class="external">查看所有游记</router-link></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'OwnReview',
        components: {},
        data () {
            return {
                userToken: ''
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '我的游记')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
				if (!this.userToken || this.userToken.length == 0) {
					this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
				}
            }
        }
    }
</script>

<style lang="less" scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .page-content{
        padding-top: 50px;
    }

    /****===== nav =====****/
    .review-nav {
        height: 44px;
        line-height: 44px;
        font-size: 13px;
        color: #777;
        border-bottom: 1px solid #e0e0e0;
    }
    .review-nav .review-nav-item {
        width: 48.7%;
        text-align: center;
    }
    .review-nav .line {
        width: 1px;
        height: 32px;
        background: #ddd;
    }
    .review-nav .active span{
        color: #061556;
        border-bottom: 2px solid #f9b811;
        padding-bottom: 6px;
    }

    /****===== list =====****/
    .list-container{
        min-height: calc(100vh - 50px - 44px);
    }
    .review-list {
        overflow-y: auto;
        padding-bottom:30px;
    }
    .review-listContainer {
        padding: 0 12px;
    }
    .review-listContainer>div:last-child{
        border:none;
    }
    .review-list-tips {
        height: 42px;
        line-height:42px;
        font-size: 12px;
        text-align:center;
        display:flex;
        flex-direction:column;
        -webkit-flex-direction:column;
        justify-content:center;
    }
    .review-list-tips >span{
        font-size:13px;
        margin:0;
        font-weight:bold;
        color:#000;
        vertical-align:middle;
    }
    .review-list-tips >span:before{
        content:"";
        width:40%;
        height:1px;
        background-color:#f1c047;
        vertical-align:middle;
        display:inline-block;
        margin-right:5%;
    }
    .review-list-tips >span:after{
        content:"";
        width:40%;
        height:1px;
        background-color:#f1c047;
        vertical-align:middle;
        display:inline-block;
        margin-left:5%;
    }
    .review-list-content {
        margin-top:12px;
        overflow: hidden;
        border-bottom:1px solid #e0e0e0;
    }
    .review-list-item {
        float: left;
        width: 172px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        padding: 6px;
        border: 1px solid #f5f4f4;
    }
    .review-list-item:nth-child(2n+1) {
        margin-right:6px;
    }
    .review-list-item>div {
        position:relative;
    }
    .review-item-imgInfo {
        width:100%;
        position:relative;
    }
    .review-item-imgInfo .review-item-img {
        width:100%;
        height:117px;
        overflow:hidden;
    }
    .review-item-imgInfo .review-item-img img{
        position:relative;
        left:50%;
        top:50%;
        transform:translate(-50%,-50%);
        -webkit-transform:translate(-50%,-50%);
        -moz-transform:translate(-50%,-50%);
        -o-transform:translate(-50%,-50%);
        -ms-transform:translate(-50%,-50%);
        max-width:100%;
        max-height:100%;
    }
    .review-item-imgInfo .review-item-imgName {
        width:100%;
        height:30px;
        line-height:30px;
        background-color:rgba(0,0,0,.5);
        color:#fff;
        font-size:12px;
        padding-left:10px;
        position:absolute;
        bottom:0;
        left:0;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .review-list-dateMD {
        margin: 4px 0 0 0;
        color: #454545;
        font-size: 12px;
        clear:both;
        text-align:center;
    }
    .review-item-status {
        position:absolute;
        top:0;
        left:0;
        background-color:rgba(0,0,0,.4);
        width:100%;
        height:100%;
        display:flex;
        flex-direction:row;
        -webkit-flex-direction:row;
        justify-content:center;
        -webkit-justify-content:center;
        align-items:center;
        -webkit-align-items:center;
        color:#fff;
        font-size:15px;
        font-weight:bold;
    }

    /** 上传成功 **/
    .review-successPic {
        display: none;
        width:100%;
        overflow:hidden;
    }
    .review-successPic img{
        width:100%;
    }

    .review-list-nodata {
        color: #091552;
        font-size:13px;
        text-align:center;
        margin-top:20px;
        font-weight:bold;
    }
    .review-list-nodata img{
        width: 10%;
    }

    .button_content {
        text-align: center;
    }

    .button_content a {
        padding: 6px 25px;
        background-color: #f7b611;
        color: #fff;
        font-size: 14px;
        border-radius: 20px;
    }
</style>
